<div class="modal-header">
  <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="row">
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-center">
      <img src="assets/images/illustration/congrats.svg" width="10%" class="img-fluid product-img mr-2" alt="product image" />
      <h4>{{ 'popst.title' | translate}}</h4>
    </div>
    <div class="row my-2">
      <div class="col-4 d-flex align-items-center justify-content-center mb-2 mb-md-0">
        <div class="d-flex align-items-center justify-content-center">
          <img *ngIf="data.status === 'Silver'" src="assets/images/silver.png" class="img-fluid product-img" alt="silver-image" />
          <img *ngIf="data.status === 'Gold'" src="assets/images/gold.png" class="img-fluid product-img" alt="gold-image" />
          <img *ngIf="data.status === 'Diamant'" src="assets/images/diamand.png" class="img-fluid product-img" alt="dia-image" />
          <img *ngIf="data.status === 'VIP'" src="assets/images/vip.png" class="img-fluid product-img" alt="vip-image" />
        </div>
      </div>
      <div class="col-8">
        <div class="mt-2">
          <span>{{ 'popst.title2' | translate}}: {{data.status}} <img src="assets/images/illustration/bravo.svg" width="10%" class="img-fluid product-img" alt="bravo"/></span>
        </div>
        <div class="mt-2">
          <span *ngIf="data.pointsCadeaux">{{ 'popst.title3' | translate}}: {{data.pointsCadeaux}} {{ 'Global.pts' | translate}} <img src="assets/images/illustration/cadeaux.svg" width="10%" class="img-fluid product-img" alt="gift"/></span>
        </div>
        <div class="mt-4">
          <h6>{{ 'popst.title4' | translate}}</h6>
        </div>        
      </div>
    </div>
  </div>
</div>